import { ALL_PROJECTS, PROJECTS_ACF_BY_SLUG } from './queries/projects'
import { sendNwReq, sendNwReqWithAuth } from './network'

const getAllProjects = async () => {
  const response = await sendNwReq(ALL_PROJECTS, {})

  // exclude projects without child category assigned
  let allProjects = response?.data?.projects?.nodes?.filter(project => {
    return project?.terms?.nodes?.length > 0
  })

  allProjects = allProjects.map(project => {
    const terms = project?.terms?.nodes[0]

    project.type = terms?.slug == 'resorts' ? 'Resort' : 'Residential'
    return project
  })

  const pageData = {
    allProjectsPosts: allProjects || [],
  }

  return pageData
}

const getAcfProjectsBySlug = async slug => {
  if (!slug) return

  const variables = { id: slug }

  const response = await sendNwReqWithAuth(PROJECTS_ACF_BY_SLUG, variables)

  return response?.data?.project
}

export { getAllProjects, getAcfProjectsBySlug }
